/**
 * Created by ZhangJunPeng on 2017/5/24.
 */

import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

const messages = defineMessages({
  result: {
    id: 'search_result'
  }
});

export function customSelect() {
  return function(Comp) {
    return injectIntl(
      class CustomSelect extends React.Component {
        constructor(props) {
          super(props);
          this.renderTopControlNode = this.renderTopControlNode.bind(this);
          this.clearSearchInput = this.clearSearchInput.bind(this);
        }

        componentDidMount() {
          try {
            this._this2 = this._a._reactInternalInstance._renderedComponent._instance;
            this._a._reactInternalInstance._renderedComponent._instance.renderTopControlNode = this.renderTopControlNode;
            this._a._reactInternalInstance._renderedComponent._instance.clearSearchInput = this.clearSearchInput;
            this._a._reactInternalInstance._renderedComponent._instance.componentDidUpdate = () => {};
            this._a._reactInternalInstance._renderedComponent._instance.onPlaceholderClick = () => {};
          } catch (e) {
            throw new Error('CustomSelect: only support TreeSelect of ANT.');
          }
        }

        clearSearchInput() {
          if (this._this2.getInputDOMNode()) {
            this._this2.getInputDOMNode().focus();
          }
          if (!('inputValue' in this._this2.props)) {
            this._this2.setState({ inputValue: '' });
          }
        }

        renderTopControlNode() {
          const value = this._this2.state.value;
          const props = this._this2.props;
          const prefixCls = props.prefixCls;
          const { intl } = this.props;
          // single and not combobox, input is inside dropdown
          let innerNode = React.createElement(
            'span',
            {
              key: 'placeholder',
              className: prefixCls + '-selection__placeholder'
            },
            props.placeholder
          );
          if (value.length) {
            innerNode = React.createElement(
              'span',
              {
                key: 'value',
                title:
                  value.length > 1
                    ? intl.formatMessage(messages.result, {
                        name: value[0].label,
                        num: value.length
                      })
                    : value[0].label,
                className: prefixCls + '-selection-selected-value'
              },
              value.length > 1
                ? intl.formatMessage(messages.result, {
                    name: value[0].label,
                    num: value.length
                  })
                : value[0].label
            );
          }
          return React.createElement(
            'span',
            { className: prefixCls + '-selection__rendered' },
            innerNode
          );
        }

        render() {
          return <Comp {...this.props} ref={a => (this._a = a)} />;
        }
      }
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/commons/CustomSelect.js